import { useEffect, useState } from 'react';
import { read, write } from '@/utils/sessionStorage';

const useStorage = <T,>(
  type: 'localStorage' | 'sessionStorage',
  key: string,
  initialValue?: T
) => {
  const [value, setValue] = useState(read(type, key, initialValue));
  useEffect(() => {
    write(type, key, value);
  }, [value, key]);

  return [value, setValue] as const;
};

export function useLocalStorage<T>(key: string, initialValue?: T) {
  return useStorage('localStorage', key, initialValue);
}

export function useSessionStorage<T>(key: string, initialValue?: T) {
  return useStorage('sessionStorage', key, initialValue);
}
